var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#004990"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2925 11.1922C29.3098 11.4661 30.1119 12.2682 30.3858 13.2855C30.8945 15.144 30.8749 19.0176 30.8749 19.0176C30.8749 19.0176 30.8749 22.8716 30.3858 24.7301C30.1119 25.7474 29.3098 26.5495 28.2925 26.8234C26.434 27.3124 19 27.3124 19 27.3124C19 27.3124 11.5854 27.3124 9.70736 26.8038C8.69007 26.5299 7.88797 25.7278 7.61408 24.7105C7.125 22.8716 7.125 18.998 7.125 18.998C7.125 18.998 7.125 15.144 7.61408 13.2855C7.88797 12.2682 8.70963 11.4466 9.70736 11.1727C11.5659 10.6836 19 10.6836 19 10.6836C19 10.6836 26.434 10.6836 28.2925 11.1922ZM22.8148 18.998L16.6328 22.5586V15.4375L22.8148 18.998Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d70b1b899b5ca2c008c4b0878577d00a.svg";
export { ForwardRef as ReactComponent };